$(document).ready(function(){
    var popupCookie = $('.cookie-popup'),
    data = popupCookie.data('cookiedata'),
    time_start = data.TimeStart*1000;  

    setTimeout(()=>{   
        if ((Cookies.get('gemmart_cookies_') == 'accepted') || popupCookie.length == 0) return;
            popupCookie.addClass('popupCookie_show');
            let btn = document.querySelector('.clickAccept'); 
            btn.addEventListener('click',(e)=>{
                e.preventDefault();
                popupCookie.removeClass('popupCookie_show');
                Cookies.set('gemmart_cookies_', 'accepted', { expires: data.continueDay, path: '/' });
            })
    },time_start);
})